import { useEffect, useRef, useState } from "react";

const TOUR_KEY = "course-chat.intro-seen.v1";
const STEPS = [
  { title: "Tu espacio para estudiar", body: "Escribe una pregunta y pulsa Enviar o Enter. Las preguntas sugeridas se envían con un clic para empezar a conversar." },
  { title: "Enfoca la consulta con @tema", body: "Elige un tema en el menú Curso. Aparecerá una etiqueta azul junto a tu mensaje para orientar la respuesta. Puedes quitarla con × o cambiarla por otro tema." },
  { title: "Practica y consulta las fuentes", body: "Comprueba ejercicios o revela respuestas dentro de cada pregunta, sin enviar mensajes nuevos. También puedes explorar fórmulas, mover los valores de los simuladores y consultar las fuentes del curso." },
];

export function IntroTour() {
  const dialogRef = useRef<HTMLDialogElement>(null);
  const headingRef = useRef<HTMLHeadingElement>(null);
  const [step, setStep] = useState(0);
  const [open, setOpen] = useState(() => {
    try { return localStorage.getItem(TOUR_KEY) !== "true"; }
    catch { return true; }
  });

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!open || !dialog) return;
    const previousFocus = document.activeElement;
    dialog.showModal();
    // Se recuerda al mostrarse, también si se recarga antes de terminar.
    try { localStorage.setItem(TOUR_KEY, "true"); } catch { /* Memoria local no disponible. */ }
    return () => {
      dialog.close();
      if (previousFocus instanceof HTMLElement) previousFocus.focus();
    };
  }, [open]);

  useEffect(() => { if (open) headingRef.current?.focus(); }, [step, open]);

  if (!open) return null;
  const current = STEPS[step];
  return (
    <dialog ref={dialogRef} className="intro-tour" aria-labelledby="intro-title" aria-describedby="intro-body" onCancel={() => setOpen(false)}>
      <span className="u-label">Guía de inicio · {step + 1} de {STEPS.length}</span>
      <h2 id="intro-title" ref={headingRef} tabIndex={-1}>{current.title}</h2>
      <p id="intro-body">{current.body}</p>
      <div className="intro-tour__actions">
        <button type="button" className="u-button u-button--ghost" onClick={() => setOpen(false)}>Omitir</button>
        {step > 0 ? <button type="button" className="u-button" onClick={() => setStep(step - 1)}>Anterior</button> : null}
        <button type="button" className="u-button u-button--primary" onClick={() => step === STEPS.length - 1 ? setOpen(false) : setStep(step + 1)}>
          {step === STEPS.length - 1 ? "Empezar" : "Siguiente"}
        </button>
      </div>
    </dialog>
  );
}
